import { render, staticRenderFns } from "./MasterDataDetail.vue?vue&type=template&id=06052084&"
import script from "./MasterDataDetail.vue?vue&type=script&lang=js&"
export * from "./MasterDataDetail.vue?vue&type=script&lang=js&"
import style0 from "./MasterDataDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports